import { useEffect } from 'react'
import useImportScript from '@/shared/hooks/useImportScript'

const TYPEFORM_EMBED_SCRIPT = '//embed.typeform.com/next/embed.js'

interface HopAssistanceChatProps {
  hidden?: boolean
}

const HopAssistanceChat = ({ hidden = false }: HopAssistanceChatProps) => {
  const { loadScript } = useImportScript()

  useEffect(() => {
    if (hidden) return

    return loadScript(TYPEFORM_EMBED_SCRIPT, false, true)
  }, [hidden, loadScript])

  if (hidden) return null

  return (
    <div
      data-testid='hop-assistance-chat'
      data-tf-chat
      data-tf-tooltip='HOP assistance'
      data-tf-popover='TcAeeiM1'
      data-tf-button-color='#0445AF'
    ></div>
  )
}

export default HopAssistanceChat
